function ensureValue(value, message) {
  if (value === undefined || value === null || value === '') {
    throw new Error(message);
  }
  return value;
}

function extractBztQrcode(responseData) {
  const qrInfo = responseData && responseData.qrInfo;
  return {
    qrcodeid: ensureValue(qrInfo && qrInfo.qrcodeid, '标证通二维码编号为空'),
    image: normalizeQrImage(ensureValue(qrInfo && qrInfo.qrimagebase64, '标证通二维码图片为空')),
  };
}

function normalizeQrImage(qrimagebase64) {
  if (/^data:image\//i.test(qrimagebase64)) return qrimagebase64;
  return `data:image/png;base64,${qrimagebase64}`;
}

function isBztPollingActive(generation, currentGeneration, visible, qrcodeid) {
  return generation === currentGeneration && Boolean(visible && qrcodeid);
}

module.exports = {
  extractBztQrcode,
  isBztPollingActive,
  normalizeQrImage,
};
